<template>
	<div>		
		<!-- <pm-navegar-pagina-vieja url="https://www.difarmer.com/alpha/"></pm-navegar-pagina-vieja> -->
		<!-- Cabecera -->
		<pm-header background="fondoInicioNuevo.png">
			<template slot="contenido">
				<div class="row h-100 justify-content-center align-items-center m-0">
					<div class="text-center text-lg-left text-white pl-lg-2">
						<h1 class="fuente-titulo">Distribuimos medicamentos</h1>
						<h4 class="fuente-subtitulo">gen&eacute;ricos de la m&aacute;s alta calidad.</h4>
					</div>
				</div>
			</template>
		</pm-header>

		<!-- Introduccion -->
		<div class="row p-0 m-0 pt-4">
			<div class="col-12 col-lg-7 col-xl-5 offset-xl-2 d-flex align-items-center">
				<div data-aos="fade-right" data-aos-delay="0">
					<p class="fuente-introduccion-titulo m-0">La fórmula de la distribución</p>
					<div class="line p-0 m-0 mt-2 mb-3"></div>
					<p
						class="fuente-introduccion-texto p-0 m-0 mt-2 mb-4"
					>Sabemos que tu objetivo principal es satisfacer las necesidades de tus clientes, por eso estamos comprometidos a ofrecerte una amplia gama de productos de calidad de los más reconocidos laboratorios, esforzándonos para brindarte el mejor servicio.</p>
				</div>
			</div>
			<div class="col-lg-5 col-xl-3 d-none d-lg-block d-flex align-items-center">
				<img class="img-fluid" ref="surtidor" src="@/assets/img-pub/Difarmer-introduccion.png" />
			</div>
		</div>

		<div class="text-center py-5 video-responsive border-top border-bottom">
			<img src="@/assets/play_btnNuevo.png" alt=""  @click="playVideo" v-show="!play">
			<video ref="video" id="video" controls v-show="play" @ended="play=false">
				<source src="https://www.difarmer.com/videos/difarmer.mp4" type="video/mp4">
			</video>			
		</div>

		<!-- Compromiso -->
		<div class="row p-0 m-0 py-4 fondo-compromiso">
			<div class="col-lg-5 col-xl-3 offset-xl-2 d-none d-lg-block d-flex align-items-center">
				<img class="img-fluid" src="@/assets/img-pub/Difarmer-compromiso.png" style="width:250px" />
			</div>
			<div class="col-12 col-lg-7 col-xl-5 d-flex align-items-center">
				<div data-aos="fade-left" data-aos-delay="500">
					<p
						class="fuente-compromiso-texto p-0 m-0 mt-2 mb-4"
					>Nos enfocamos en que recibas tu pedido en tiempo y forma. Preparándonos constantemente mediante la aplicación de tecnologías y sistemas productivos de vanguardia; para proporcionarte soluciones innovadoras, con el fin de que cumplas tus objetivos.</p>
				</div>
			</div>
		</div>

		<!-- Separador -->
		<div class="row-fluid fondo-separador text-white text-center py-3 py-lg-4 py-xl-5">
			<div class="col-12">
				<span class="fuente-separador">Distribuimos en toda la república mexicana.</span>
			</div>
		</div>

		<!-- Laboratorios -->
		<pm-laboratorios></pm-laboratorios>

		<!-- Carro contacto -->
		<pm-carro-contacto></pm-carro-contacto>

		<!-- Pie pagina -->
		<pm-pie-pagina></pm-pie-pagina>		
	</div>
</template>


<script>
	
	import PmHeader from "@/components/publica/Header"
	import PmLaboratorios from "@/components/publica/Laboratorios"
	import PmCarroContacto from "@/components/publica/CarroContacto"
	import PmPiePagina from "@/components/publica/PiePagina"
	import simpleParallax from "simple-parallax-js"
	// import PmNavegarPaginaVieja from '@/components/NavegarPaginaVieja'
		
	export default {
		data(){
			return {
				play:false
			}
		},
		mounted() {		
			
			// if(process.env.NODE_ENV != "development"){
			// 	if (location.protocol !== 'https:') {
			// 		location.replace(`https:${location.href.substring(location.protocol.length)}`);
			// 	}
			// }

			let imagen = this.$refs.surtidor
			new simpleParallax(imagen, {
				scale: 3.5,
				overflow: true,
				delay: 2.6
			})
			//this.ocultarChat()
		},
		components: {
			PmHeader,
			PmLaboratorios,
			PmCarroContacto,
			PmPiePagina,			
			// PmNavegarPaginaVieja
		},
		methods:{
			playVideo(){
				this.play = true
				//this.refs.video.play()
				this.$nextTick(()=>{
					this.$refs.video.play()
				})				
				
			}
		}
	}
</script>

<style scoped lang="scss">
	.video-responsive{	
		display: flex;			
		justify-content: center;
		video, img{
			width: 100%;
			max-width: 720px;
			height: 405px;
			max-height: 405px;			
		}
		img{
			cursor: pointer;
		}
	}
	
	/* Cabecera */
	.fuente-titulo {
		font-weight: 600;
	}
	/* Introduccion */
	.fuente-introduccion-titulo {
		font-weight: 600;
		font-style: italic;
		color: var(--color-azul-dark);
	}
	.fuente-introduccion-subtitulo {
		font-family: "Open Sans", sans-serif;
		color: var(--color-azul-dark);
	}
	.fuente-introduccion-texto {
		font-family: "Open Sans", sans-serif;
		color: var(--color-azul-dark);
	}
	/* Compromiso */
	.fondo-compromiso {
		background-color: var(--color-gris-light);
		position: relative;
		z-index: 2;
	}
	.fuente-compromiso-titulo {
		font-weight: 600;
		font-style: italic;
		color: var(--color-azul-dark);
	}
	.fuente-compromiso-subtitulo {
		font-family: "Open Sans", sans-serif;
		color: var(--color-azul-dark);
	}
	.fuente-compromiso-texto {
		font-family: "Open Sans", sans-serif;
		color: var(--color-azul-dark);
	}
	/* Separador */
	.fondo-separador {
		background-color: var(--color-azul);
		font-weight: 600;
	}
	/*  */
	.line {
		width: 15%;
		min-height: 0.05rem;
		background-color: var(--color-azul-dark);
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		/* Cabecera */
		.fuente-titulo {
			font-size: 20px !important;
		}
		.fuente-subtitulo {
			font-size: 20px !important;
		}
		/* Introduccion */
		.fuente-introduccion-titulo {
			font-size: 20px !important;
		}
		.fuente-introduccion-subtitulo {
			font-size: 20px !important;
		}
		.fuente-introduccion-texto {
			font-size: 14px !important;
		}
		/* Compromiso */
		.fuente-compromiso-titulo {
			font-size: 20px !important;
		}
		.fuente-compromiso-subtitulo {
			font-size: 20px !important;
		}
		.fuente-compromiso-texto {
			font-size: 14px !important;
		}
		/* Separador */
		.fuente-separador {
			font-size: 16px !important;
		}
		.d-none {
			display: none !important;
		}
	}

	/* sm */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		/* Cabecera */
		.fuente-titulo {
			font-size: 28px !important;
		}
		.fuente-subtitulo {
			font-size: 28px !important;
		}
		/* Introduccion */
		.fuente-introduccion-titulo {
			font-size: 20px !important;
		}
		.fuente-introduccion-subtitulo {
			font-size: 20px !important;
		}
		.fuente-introduccion-texto {
			font-size: 16px !important;
		}
		/* Compromiso */
		.fuente-compromiso-titulo {
			font-size: 20px !important;
		}
		.fuente-compromiso-subtitulo {
			font-size: 20px !important;
		}
		.fuente-compromiso-texto {
			font-size: 16px !important;
		}
		/* Separador */
		.fuente-separador {
			font-size: 18px !important;
		}
		.d-none {
			display: none !important;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		/* Cabecera */
		.fuente-titulo {
			font-size: 32px !important;
		}
		.fuente-subtitulo {
			font-size: 32px !important;
		}
		/* Introduccion */
		.fuente-introduccion-titulo {
			font-size: 24px !important;
		}
		.fuente-introduccion-subtitulo {
			font-size: 24px !important;
		}
		.fuente-introduccion-texto {
			font-size: 18px !important;
		}
		/* Compromiso */
		.fuente-compromiso-titulo {
			font-size: 24px !important;
		}
		.fuente-compromiso-subtitulo {
			font-size: 24px !important;
		}
		.fuente-compromiso-texto {
			font-size: 18px !important;
		}
		/* Separador */
		.fuente-separador {
			font-size: 18px !important;
		}
		.d-none {
			display: none !important;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		/* Cabecera */
		.fuente-titulo {
			font-size: 43px !important;
		}
		.fuente-subtitulo {
			font-size: 43px !important;
		}
		/* Introduccion */
		.fuente-introduccion-titulo {
			font-size: 28px !important;
		}
		.fuente-introduccion-subtitulo {
			font-size: 28px !important;
		}
		.fuente-introduccion-texto {
			font-size: 18px !important;
		}
		/* Compromiso */
		.fuente-compromiso-titulo {
			font-size: 28px !important;
		}
		.fuente-compromiso-subtitulo {
			font-size: 28px !important;
		}
		.fuente-compromiso-texto {
			font-size: 18px !important;
		}
		/* Separador */
		.fuente-separador {
			font-size: 24px !important;
		}
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
		/* Cabecera */
		.fuente-titulo {
			font-size: 55px !important;
		}
		.fuente-subtitulo {
			font-size: 55px !important;
		}
		/* Introduccion */
		.fuente-introduccion-titulo {
			font-size: 32px !important;
		}
		.fuente-introduccion-subtitulo {
			font-size: 32px !important;
		}
		.fuente-introduccion-texto {
			font-size: 20px !important;
		}
		/* Compromiso */
		.fuente-compromiso-titulo {
			font-size: 32px !important;
		}
		.fuente-compromiso-subtitulo {
			font-size: 32px !important;
		}
		.fuente-compromiso-texto {
			font-size: 20px !important;
		}
		/* Separador */
		.fuente-separador {
			font-size: 26px !important;
		}
	}
</style>